import { PhoneOff, AlertCircle } from "lucide-react";

const SEV_COLOR = {
  Critical: "text-[#FF3B30] border-[#FF3B30]/40",
  High: "text-[#FF9500] border-[#FF9500]/40",
  Medium: "text-[#B8860B] border-[#B8860B]/40",
  Low: "text-[#007AFF] border-[#007AFF]/40",
};

const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString();
};

export const UnmatchedReports = ({ incidents, loading }) => (
  <div className="border border-border bg-[#0A0A0A] rounded-sm p-6" data-testid="admin-unmatched-reports">
    <div className="flex items-center justify-between mb-1">
      <div className="flex items-center gap-2">
        <PhoneOff className="w-4 h-4 text-amber-500" />
        <h2 className="font-heading text-lg font-black tracking-tight">Unmatched reports</h2>
      </div>
      {!loading && (
        <span data-testid="unmatched-count"
          className={`text-xs font-mono font-bold px-2 py-0.5 border rounded-sm ${
            incidents.length ? "text-amber-500 border-amber-500/40" : "text-muted-foreground border-border"}`}>
          {incidents.length}
        </span>
      )}
    </div>
    <p className="text-xs text-muted-foreground mb-4 max-w-2xl">
      Calls whose caller number didn't match any user's saved phone. These reports aren't shown on anyone's
      dashboard — ask the caller to add that number to their profile so it gets linked.
    </p>

    {loading ? (
      <p className="text-sm text-muted-foreground font-mono">Loading…</p>
    ) : incidents.length === 0 ? (
      <div className="flex items-center gap-2 text-sm text-muted-foreground" data-testid="unmatched-empty">
        <AlertCircle className="w-4 h-4 text-emerald-500" />
        Every report is linked to a user — nothing orphaned.
      </div>
    ) : (
      <div className="space-y-2" data-testid="unmatched-list">
        {incidents.map((inc) => (
          <div key={inc.id} data-testid={`unmatched-row-${inc.id}`}
            className="flex items-start justify-between gap-4 border-b border-border pb-2 last:border-0 last:pb-0">
            <div className="min-w-0">
              <p className="text-sm truncate">
                <span className="text-muted-foreground font-mono mr-2">#{inc.incident_number || "—"}</span>
                {inc.title || "Incident"}
              </p>
              <p className="text-[11px] text-muted-foreground font-mono">
                Caller: {inc.caller_number || "unknown"} · {fmtDate(inc.created_at)}
              </p>
            </div>
            <span className={`shrink-0 text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 border rounded-sm ${
              SEV_COLOR[inc.severity] || "text-muted-foreground border-border"}`}>
              {inc.severity || "—"}
            </span>
          </div>
        ))}
      </div>
    )}
  </div>
);
